<template>
  <section class="section section-code">
    <div class="tech-bg">
      <div class="grid-overlay"></div>
      <div class="floating-particles">
        <div class="particle" v-for="n in 30" :key="n" :style="particleStyle(n)"></div>
      </div>
      <div class="glow-orb glow-orb-1"></div>
      <div class="glow-orb glow-orb-2"></div>
      <div class="glow-orb glow-orb-3"></div>
      <div class="hex-grid"></div>
    </div>
    <div class="container">
      <div class="page-head">
        <h2>AI 编码提示词工具</h2>
        <p>通过可视化界面生成AI编码提示词</p>
      </div>
      
      <div class="main-content">
        <!-- 上方控件库 -->
        <div class="sidebar">
          <!-- 生成选项 -->
          <div class="generate-options">
            <label>生成选项</label>
            <textarea
              v-model="generateOptions"
              :rows="3"
              placeholder="生成选项..."
              class="textarea"
            >生成 单HTML 页面
生成 PySide6 界面代码</textarea>
          </div>

          <!-- 控件库 -->
          <div class="control-section">
            <h3>界面伪代码编辑</h3>
            <p class="hint">点击下方片段插入</p>

            <!-- 容器类 -->
            <div class="control-group">
              <h4>容器 (16项)</h4>
              <div class="control-buttons">
                <button class="control-btn" @click="insertCode(`Window(title='窗口标题', layout='水平可行', colorStyle='黑白')`)">窗口/页面</button>
                <button class="control-btn" @click="insertCode(`Dialog(title='对话框标题', layout='垂直可行', modal=True)`)">对话框</button>
                <button class="control-btn" @click="insertCode(`RowContainer(spacing=10, alignment='居中')`)">行容器</button>
                <button class="control-btn" @click="insertCode(`ColumnContainer(spacing=10, alignment='居中')`)">列容器</button>
                <button class="control-btn" @click="insertCode(`TopBar(height=60, background='#f5f5f5')`)">顶部栏</button>
                <button class="control-btn" @click="insertCode(`NavBar(items=['首页', '功能', '关于'], active='首页')`)">导航栏</button>
                <button class="control-btn" @click="insertCode(`ToolBar(buttons=['新建', '打开', '保存'])`)">工具栏</button>
                <button class="control-btn" @click="insertCode(`BottomBar(height=40, text='版权信息')`)">底部栏</button>
                <button class="control-btn" @click="insertCode(`SideBar(width=200, items=['选项1', '选项2'])`)">侧边栏</button>
                <button class="control-btn" @click="insertCode(`ContentArea(padding=20)`)">内容区</button>
                <button class="control-btn" @click="insertCode(`GridArea(rows=3, cols=3, spacing=10)`)">网格区</button>
                <button class="control-btn" @click="insertCode(`GroupBox(title='分组', layout='垂直可行')`)">GroupBox</button>
                <button class="control-btn" @click="insertCode(`TabWidget(tabs=['标签1', '标签2'], active=0)`)">标签页</button>
                <button class="control-btn" @click="insertCode(`CollapsePanel(title='折叠面板', content='内容')`)">折叠面板</button>
                <button class="control-btn" @click="insertCode(`Form(layout='垂直可行', padding=20)`)">表单</button>
                <button class="control-btn" @click="insertCode(`FunctionDef(name='函数名', params=['参数1', '参数2'])`)">函数定义</button>
              </div>
            </div>

            <!-- 控件类 -->
            <div class="control-group">
              <h4>控件 (26项)</h4>
              <div class="control-buttons">
                <button class="control-btn" @click="insertCode(`Label(text='文字标签', alignment='左对齐')`)">文字标签</button>
                <button class="control-btn" @click="insertCode(`Button(text='按钮', onClick='函数名()')`)">按钮</button>
                <button class="control-btn" @click="insertCode(`LineEdit(placeholder='输入文字', value='默认值')`)">单行输入框</button>
                <button class="control-btn" @click="insertCode(`TextEdit(placeholder='输入多行文字', value='默认值')`)">多行输入框</button>
                <button class="control-btn" @click="insertCode(`Title(text='标题', level=1)`)">标题</button>
                <button class="control-btn" @click="insertCode(`Menu(items=['菜单项1', '菜单项2'])`)">菜单</button>
                <button class="control-btn" @click="insertCode(`Image(src='图片路径', width=100, height=100)`)">图片</button>
                <button class="control-btn" @click="insertCode(`Link(text='链接文本', url='链接地址')`)">链接</button>
                <button class="control-btn" @click="insertCode(`HorizontalLine(height=1, color='#e0e0e0')`)">水平分隔线</button>
                <button class="control-btn" @click="insertCode(`VerticalLine(width=1, color='#e0e0e0')`)">垂直分隔线</button>
                <button class="control-btn" @click="insertCode(`DataTable(columns=['列1', '列2'], data=[[1, '数据']])`)">数据表</button>
                <button class="control-btn" @click="insertCode(`TreeWidget(items=[{'text': '节点1', 'children': []}])`)">树控件</button>
                <button class="control-btn" @click="insertCode(`DatePicker(value='2023-01-01')`)">日期选择</button>
                <button class="control-btn" @click="insertCode(`TimePicker(value='12:00')`)">时间选择</button>
                <button class="control-btn" @click="insertCode(`DateTimePicker(value='2023-01-01 12:00')`)">日期+时间选择</button>
                <button class="control-btn" @click="insertCode(`ComboBox(items=['选项1', '选项2'], value='选项1')`)">下拉选择</button>
                <button class="control-btn" @click="insertCode(`ListBox(items=['选项1', '选项2'], value='选项1')`)">列表选择</button>
                <button class="control-btn" @click="insertCode(`RadioButton(name='组名', items=['选项1', '选项2'], value='选项1')`)">单选</button>
                <button class="control-btn" @click="insertCode(`CheckBox(text='勾选框', checked=True)`)">勾选</button>
                <button class="control-btn" @click="insertCode(`Switch(text='开关', checked=True)`)">开关</button>
                <button class="control-btn" @click="insertCode(`NumberInput(value=0, min=0, max=100)`)">数字输入框</button>
                <button class="control-btn" @click="insertCode(`PasswordInput(placeholder='输入密码')`)">密码框</button>
                <button class="control-btn" @click="insertCode(`SearchInput(placeholder='搜索')`)">搜索框</button>
                <button class="control-btn" @click="insertCode(`Slider(value=50, min=0, max=100)`)">滑块</button>
                <button class="control-btn" @click="insertCode(`ProgressBar(value=50, max=100)`)">进度条</button>
                <button class="control-btn" @click="insertCode(`Badge(text='1', color='红色')`)">徽标</button>
              </div>
            </div>

            <!-- 属性类 -->
            <div class="control-group">
              <h4>属性 (27项)</h4>
              <div class="control-buttons">
                <button class="control-btn" @click="insertCode(`name='控件名称'`)">名字</button>
                <button class="control-btn" @click="insertCode(`text='显示文字'`)">文字</button>
                <button class="control-btn" @click="insertCode(`category='类别'`)">类别</button>
                <button class="control-btn" @click="insertCode(`alignment='左对齐'`)">对齐</button>
                <button class="control-btn" @click="insertCode(`width=100`)">宽度</button>
                <button class="control-btn" @click="insertCode(`height=30`)">高度</button>
                <button class="control-btn" @click="insertCode(`minWidth=50`)">最小宽度</button>
                <button class="control-btn" @click="insertCode(`minHeight=20`)">最小高度</button>
                <button class="control-btn" @click="insertCode(`maxWidth=200`)">最大宽度</button>
                <button class="control-btn" @click="insertCode(`maxHeight=100`)">最大高度</button>
                <button class="control-btn" @click="insertCode(`widthRatio=1`)">占父容器宽度比例</button>
                <button class="control-btn" @click="insertCode(`heightRatio=1`)">占父容器高度比例</button>
                <button class="control-btn" @click="insertCode(`backgroundColor='#ffffff'`)">背景色</button>
                <button class="control-btn" @click="insertCode(`fontColor='#333333'`)">字体色</button>
                <button class="control-btn" @click="insertCode(`fontSize=14`)">字体大小</button>
                <button class="control-btn" @click="insertCode(`fontWeight='normal'`)">字体粗细</button>
                <button class="control-btn" @click="insertCode(`cursor='pointer'`)">鼠标样式</button>
                <button class="control-btn" @click="insertCode(`borderRadius=4`)">圆角</button>
                <button class="control-btn" @click="insertCode(`border='1px solid #e0e0e0'`)">边框</button>
                <button class="control-btn" @click="insertCode(`shadow='0 2px 4px rgba(0,0,0,0.1)'`)">阴影</button>
                <button class="control-btn" @click="insertCode(`opacity=1`)">透明度</button>
                <button class="control-btn" @click="insertCode(`margin=10`)">外距</button>
                <button class="control-btn" @click="insertCode(`padding=10`)">内距</button>
                <button class="control-btn" @click="insertCode(`childrenLayout='水平可行'`)">子元素布局</button>
                <button class="control-btn" @click="insertCode(`childrenSpacing=10`)">子元素间距</button>
                <button class="control-btn" @click="insertCode(`childrenAlignment='居中'`)">子元素水平对齐</button>
                <button class="control-btn" @click="insertCode(`childrenVerticalAlignment='居中'`)">子元素垂直对齐</button>
              </div>
            </div>

            <!-- 事件类 -->
            <div class="control-group">
              <h4>事件 (11项)</h4>
              <div class="control-buttons">
                <button class="control-btn" @click="insertCode(`onClick='函数名()'`)">点击</button>
                <button class="control-btn" @click="insertCode(`onDoubleClick='函数名()'`)">双击</button>
                <button class="control-btn" @click="insertCode(`onHover='函数名()'`)">鼠标悬停</button>
                <button class="control-btn" @click="insertCode(`onMouseEnter='函数名()'`)">鼠标移入</button>
                <button class="control-btn" @click="insertCode(`onMouseLeave='函数名()'`)">鼠标移出</button>
                <button class="control-btn" @click="insertCode(`onInput='函数名()'`)">输入变化</button>
                <button class="control-btn" @click="insertCode(`onFocus='函数名()'`)">聚焦</button>
                <button class="control-btn" @click="insertCode(`onBlur='函数名()'`)">失焦</button>
                <button class="control-btn" @click="insertCode(`onKeyDown='函数名()'`)">按键按下</button>
                <button class="control-btn" @click="insertCode(`onKeyUp='函数名()'`)">按键抬起</button>
                <button class="control-btn" @click="insertCode(`onChange='函数名()'`)">选择项变化</button>
              </div>
            </div>
          </div>
        </div>

        <!-- 下方伪代码编辑区 -->
        <div class="editor">
          <div class="editor-header">
            <h3>伪代码编辑区</h3>
            <p class="hint">点击上方片段插入；有选中文本时会直接替换</p>
          </div>
          <textarea
            v-model="pseudocode"
            class="editor-textarea"
            placeholder="点击上方控件生成伪代码..."
          ></textarea>
          <div class="editor-footer">
            <div class="action-buttons">
              <button class="btn primary" @click="generatePrompt">生成提示词</button>
              <button class="btn second" @click="copyPseudocode">复制伪代码</button>
              <button class="btn second" @click="clearPseudocode">清空伪代码</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { authMixin } from '../utils/authMixin'

export default {
  name: 'Code',
  mixins: [authMixin],
  data() {
    return {
      generateOptions: '生成 单HTML 页面\n生成 PySide6 界面代码',
      pseudocode: ''
    }
  },
  methods: {
    particleStyle() {
      const size = Math.random() * 4 + 1
      const left = Math.random() * 100
      const top = Math.random() * 100
      const duration = Math.random() * 20 + 10
      const delay = Math.random() * 10
      return {
        width: `${size}px`,
        height: `${size}px`,
        left: `${left}%`,
        top: `${top}%`,
        animationDuration: `${duration}s`,
        animationDelay: `${delay}s`
      }
    },
    insertCode(code) {
      const textarea = document.querySelector('.editor-textarea')
      if (textarea) {
        const start = textarea.selectionStart
        const end = textarea.selectionEnd
        const text = this.pseudocode
        this.pseudocode = text.substring(0, start) + code + '\n' + text.substring(end)
        
        this.$nextTick(() => {
          textarea.focus()
          textarea.selectionStart = start + code.length + 1
          textarea.selectionEnd = start + code.length + 1
        })
      }
    },
    generatePrompt() {
      if (!this.generateOptions.trim()) {
        alert('请设置生成选项')
        return
      }
      
      if (!this.pseudocode.trim()) {
        alert('请先添加伪代码')
        return
      }

      this.pseudocode = `${this.generateOptions}\n\n${this.pseudocode}`
      alert('提示词生成成功！')
    },
    copyPseudocode() {
      if (!this.pseudocode) {
        alert('没有内容可复制')
        return
      }

      navigator.clipboard.writeText(this.pseudocode)
        .then(() => {
          alert('复制成功！')
        })
        .catch(err => {
          alert('复制失败，请手动复制')
          console.error('复制失败:', err)
        })
    },
    clearPseudocode() {
      if (confirm('确定要清空所有内容吗？')) {
        this.pseudocode = ''
      }
    }
  }
}
</script>

<style scoped>
.section-code {
  padding-top: 100px;
  padding-bottom: 100px;
  box-sizing: border-box;
  background: linear-gradient(180deg, #0a0e1a 0%, #0d1224 50%, #0a0e1a 100%);
  position: relative;
  min-height: 100vh;
}

.tech-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
  overflow: hidden;
}

.grid-overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: 
    linear-gradient(rgba(0, 230, 172, 0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0, 230, 172, 0.03) 1px, transparent 1px);
  background-size: 50px 50px;
  animation: gridMove 20s linear infinite;
}

@keyframes gridMove {
  0% { transform: translate(0, 0); }
  100% { transform: translate(50px, 50px); }
}

.floating-particles {
  position: absolute;
  width: 100%;
  height: 100%;
}

.particle {
  position: absolute;
  background: rgba(0, 230, 172, 0.4);
  border-radius: 50%;
  animation: floatParticle linear infinite;
  filter: blur(1px);
  box-shadow: 0 0 8px rgba(0, 230, 172, 0.3);
}

@keyframes floatParticle {
  0% { transform: translateY(0) translateX(0); opacity: 0; }
  10% { opacity: 1; }
  90% { opacity: 1; }
  100% { transform: translateY(-100vh) translateX(50px); opacity: 0; }
}

.glow-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(60px);
  opacity: 0.15;
}

.glow-orb-1 {
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, rgba(0, 204, 153, 0.6) 0%, transparent 70%);
  top: 20%;
  left: 10%;
  animation: floatOrb1 15s ease-in-out infinite;
}

.glow-orb-2 {
  width: 300px;
  height: 300px;
  background: radial-gradient(circle, rgba(0, 230, 172, 0.6) 0%, transparent 70%);
  top: 50%;
  right: 15%;
  animation: floatOrb2 18s ease-in-out infinite;
}

.glow-orb-3 {
  width: 350px;
  height: 350px;
  background: radial-gradient(circle, rgba(79, 172, 254, 0.6) 0%, transparent 70%);
  bottom: 10%;
  left: 50%;
  animation: floatOrb3 20s ease-in-out infinite;
}

@keyframes floatOrb1 {
  0%, 100% { transform: translate(0, 0); }
  50% { transform: translate(100px, -50px); }
}

@keyframes floatOrb2 {
  0%, 100% { transform: translate(0, 0); }
  50% { transform: translate(-80px, 80px); }
}

@keyframes floatOrb3 {
  0%, 100% { transform: translate(0, 0); }
  50% { transform: translate(-60px, -100px); }
}

.hex-grid {
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='28' height='49' viewBox='0 0 28 49'%3E%3Cg fill-rule='evenodd'%3E%3Cg fill='%2300e6ac' fill-opacity='0.02'%3E%3Cpath d='M13.99 9.25l13 7.5v15l-13 7.5L1 31.75v-15l12.99-7.5zM3 17.9v12.7l10.99 6.34 11-6.35V17.9l-11-6.34L3 17.9zM0 15l12.98-7.5V0h-2v6.35L0 12.69v2.3zm0 18.5L12.98 41v8h-2v-6.85L0 35.81v-2.3zM15 0v7.5L27.99 15H28v-2.31h-.01L17 6.35V0h-2zm0 49v-8l12.99-7.5H28v2.31h-.01L17 42.15V49h-2z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  opacity: 0.4;
}

.container {
  position: relative;
  z-index: 1;
}

.page-head {
  text-align: center;
  margin-bottom: 30px;
}

.page-head h2 {
  font-size: 32px;
  margin-bottom: 10px;
}

.page-head p {
  color: #888;
  font-size: 16px;
}

.main-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  flex-direction: column;
  gap: 25px;
}

/* 上方控件库 */
.sidebar {
  display: flex;
  flex-direction: column;
  gap: 25px;
}

/* 生成选项 */
.generate-options {
  background: rgba(255,255,255,0.03);
  border: 1px solid rgba(255,255,255,0.06);
  border-radius: 12px;
  padding: 20px;
}

.generate-options label {
  display: block;
  margin-bottom: 10px;
  color: #aaa;
  font-size: 14px;
}

.textarea {
  width: 100%;
  padding: 12px 16px;
  background: #1a1e2d;
  border: 1px solid #333;
  border-radius: 8px;
  color: #fff;
  outline: none;
  resize: vertical;
  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
  font-size: 14px;
}

.textarea:focus {
  border-color: #00e6ac;
}

/* 控件库 */
.control-section {
  background: rgba(255,255,255,0.03);
  border: 1px solid rgba(255,255,255,0.06);
  border-radius: 12px;
  padding: 25px;
  max-height: 500px;
  overflow-y: auto;
}

.control-section h3 {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 8px;
  color: #fff;
}

.control-section .hint {
  font-size: 12px;
  color: #666;
  margin-bottom: 20px;
}

.control-group {
  margin-bottom: 20px;
}

.control-group h4 {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #00e6ac;
  border-bottom: 1px solid rgba(255,255,255,0.05);
  padding-bottom: 5px;
}

.control-buttons {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
}

.control-btn {
  padding: 8px 12px;
  border: 1px solid rgba(255,255,255,0.1);
  border-radius: 6px;
  background: rgba(255,255,255,0.02);
  font-size: 12px;
  color: #ccc;
  cursor: pointer;
  transition: all 0.2s;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.control-btn:hover {
  border-color: #00e6ac;
  color: #00e6ac;
  background: rgba(0,230,172,0.05);
}

.control-btn:active {
  background: rgba(0,230,172,0.1);
}

/* 下方伪代码编辑区 */
.editor {
  background: rgba(255,255,255,0.03);
  border: 1px solid rgba(255,255,255,0.06);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  min-height: 300px;
}

.editor-header {
  padding: 20px 25px;
  border-bottom: 1px solid rgba(255,255,255,0.05);
}

.editor-header h3 {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 5px;
  color: #fff;
}

.editor-header .hint {
  font-size: 12px;
  color: #666;
  margin-bottom: 0;
}

.editor-textarea {
  flex: 1;
  padding: 20px 25px;
  border: none;
  resize: none;
  font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
  font-size: 14px;
  line-height: 1.6;
  color: #fff;
  background: rgba(0,0,0,0.2);
  min-height: 200px;
}

.editor-textarea:focus {
  outline: none;
  background: rgba(0,0,0,0.3);
}

.editor-footer {
  padding: 15px 25px;
  border-top: 1px solid rgba(255,255,255,0.05);
  background: rgba(0,0,0,0.1);
  border-radius: 0 0 12px 12px;
}

.action-buttons {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

/* 响应式 */
@media (max-width: 1024px) {
  .control-buttons {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (max-width: 768px) {
  .control-buttons {
    grid-template-columns: repeat(3, 1fr);
  }
  
  .action-buttons {
    flex-direction: column;
  }
  
  .editor {
    min-height: 250px;
  }
  
  .control-section {
    max-height: 400px;
  }
}

/* 滚动条样式 */
.control-section::-webkit-scrollbar {
  width: 6px;
}

.control-section::-webkit-scrollbar-track {
  background: rgba(255,255,255,0.05);
  border-radius: 3px;
}

.control-section::-webkit-scrollbar-thumb {
  background: rgba(255,255,255,0.1);
  border-radius: 3px;
}

.control-section::-webkit-scrollbar-thumb:hover {
  background: rgba(255,255,255,0.2);
}
</style>
